import { render } from "./CriarSalaModal.vue?vue&type=template&id=79297bdf&scoped=true"
import script from "./CriarSalaModal.vue?vue&type=script&lang=js"
export * from "./CriarSalaModal.vue?vue&type=script&lang=js"

import "./CriarSalaModal.vue?vue&type=style&index=0&id=79297bdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79297bdf"]])

export default __exports__